<template>
  <div class="image-tooltip-wrapper">
    <el-popover
      :disabled="!url"
      trigger="hover"
      placement="bottom-start"
      popper-class="image-popover">
      <div class="image-tooltip">
        <img :src="url" :alt="title" v-if="url">
        <i class="far fa-image" v-if="!url"/>
      </div>
      <span
        slot="reference"
        :class="['image', {'round':round}]"
        :style="{backgroundImage: `url(${url})`, height: size, width: size}">
        <i class="far fa-image" v-if="!url"/>
      </span>
    </el-popover>
    {{title}}
  </div>
</template>

<script>
export default {
  name: 'ImageTooltip',
  props: {
    url: { type: String, default: '' },
    title: { type: String, default: '' },
    round: { type: Boolean, default: true },
    size: { type: String, default: '3rem' }
  }
}
</script>

<style lang="stylus">
  .image-tooltip-wrapper {
    white-space nowrap
    > span {
      vertical-align middle
      display inline-block
      .image {
        display block
        background-size cover
      }
    }
  }
</style>
